module.exports = __webpack_public_path__ + "static/drag&Drop-1e32a5352dd582249af7378855255a94.svg";